module.exports = __webpack_public_path__ + "static/media/clientsNavbar.6b904922.svg";